import { BATHROOM_CDN_PATH, BATHROOM_PATH } from '../../old-bathroom-constants';
import { AssortmentSectionCardStructure } from './assortment-section-types';

const ASSORTMENT_SECTION_CDN = 'assortment';

export const ASSORTMENT_SECTION_CARD_LIST: AssortmentSectionCardStructure[] = [
  {
    link: {
      href: `${BATHROOM_PATH}stili/?style-name=design`,
      title: 'assortment-section.design.link-title',
    },
    card: {
      media: {
        alt: 'assortment-section.design.link-title',
        src: `${BATHROOM_CDN_PATH}/${ASSORTMENT_SECTION_CDN}/design.jpg/design.jpg`,
      },
      content: {
        title: 'assortment-section.design.title',
        description: 'assortment-section.design.description',
      },
    },
  },
  {
    link: {
      href: `${BATHROOM_PATH}stili/?style-name=neo`,
      title: 'assortment-section.neoclassic.link-title',
    },
    card: {
      media: {
        alt: 'assortment-section.neoclassic.link-title',
        src: `${BATHROOM_CDN_PATH}/${ASSORTMENT_SECTION_CDN}/neoclassic.jpg/neoclassic.jpg`,
      },
      content: {
        title: 'assortment-section.neoclassic.title',
        description: 'assortment-section.neoclassic.description',
      },
    },
  },
  {
    link: {
      href: `${BATHROOM_PATH}stili/?style-name=skand`,
      title: 'assortment-section.scandinavian.link-title',
    },
    card: {
      media: {
        alt: 'assortment-section.scandinavian.link-title',
        src: `${BATHROOM_CDN_PATH}/${ASSORTMENT_SECTION_CDN}/scandinavian.jpg/scandinavian.jpg`,
      },
      content: {
        title: 'assortment-section.scandinavian.title',
        description: 'assortment-section.scandinavian.description',
      },
    },
  },
  {
    link: {
      href: `${BATHROOM_PATH}stili/?style-name=nature`,
      title: 'assortment-section.nature.link-title',
    },
    card: {
      media: {
        alt: 'assortment-section.nature.link-title',
        src: `${BATHROOM_CDN_PATH}/${ASSORTMENT_SECTION_CDN}/nature.jpg/nature.jpg`,
      },
      content: {
        title: 'assortment-section.nature.title',
        description: 'assortment-section.nature.description',
      },
    },
  },
  {
    link: {
      href: `${BATHROOM_PATH}stili/?style-name=sharm`,
      title: 'assortment-section.charm.link-title',
    },
    card: {
      media: {
        alt: 'assortment-section.charm.link-title',
        src: `${BATHROOM_CDN_PATH}/${ASSORTMENT_SECTION_CDN}/charm.jpg/charm.jpg`,
      },
      content: {
        title: 'assortment-section.charm.title',
        description: 'assortment-section.charm.description',
      },
    },
  },
];
